import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Agregar gestor',
    first_name: {
      label: 'Nombre',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Apellido',
      placeholder: 'White',
    },
    city: {
      label: 'Ciudad',
      placeholder: 'Bonn',
    },
    email: {
      label: 'Correo electrónico',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Rol',
      placeholder: 'Seleccionar rol',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Propietario',
      options: {
        [ManagerRole.Admin]: 'Admin',
        [ManagerRole.Reseller]: 'Revendedor',
        [ManagerRole.SalesManager]: 'Gerente de ventas',
        [ManagerRole.SalesLeadership]: 'Líder de ventas',
        [ManagerRole.ContentManager]: 'Gestor de contenido',
        [ManagerRole.OnboardingManager]: 'Gestor de incorporación',
        [ManagerRole.MobileAppsManager]: 'Gestor de apps móviles',
        [ManagerRole.StoreAdmin]: 'Admin',
        [ManagerRole.StoreEmployee]: 'Empleado',
        [ManagerRole.StoreOperator]: 'Operador',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operador:</strong> Acceso completo a Ventas, Menú, Top Artículos, Horarios, Tarjetas de regalo, Reservas e Informes para las empresas asignadas.',
        [ManagerRole.StoreEmployee]: '<strong>Empleado:</strong> Acceso limitado solo a Reservas y Tarjetas de regalo.',
        [ManagerRole.StoreAdmin]:
          '<strong>Propietario:</strong> Acceso total a un restaurante, incluyendo tienda, configuración de impuestos, marketing y gestión de equipo. Recibe un correo con su acceso. Un propietario por restaurante, y otros miembros del equipo no pueden editarlo ni eliminarlo.',
      },
    },
    companies: {
      label: 'Empresas',
      placeholder: 'Seleccionar empresas',
      owner_placeholder: 'Seleccionar restaurante',
      has_owner: 'Tiene un propietario',
    },
  },
  fields: {
    email: 'Correo electrónico',
    name: 'Nombre',
    roles: 'Rol',
    created_at: 'Creado',
    actions: 'Acciones',
    companies: 'Empresas',
    status: 'Estado',
  },
  tags: {
    owner: 'Propietario',
  },
  search: {
    placeholder: 'Buscar por nombre o correo',
  },
  buttons: {
    add_manager: 'Agregar gestor',
    actions: 'Acciones',
    view_dashboard: 'Ver panel como este gestor',
    login_as_manager: 'Iniciar sesión como este gestor',
    delete: 'Eliminar este gestor',
    resend_owner_invite: 'Reenviar la invitación al propietario',
  },
  modals: {
    delete_manager: {
      title: '¿Eliminar al gestor {{email}}?',
    },
    update_manager: {
      title: '¿Actualizar al gestor {{email}}?',
    },
    resend_owner_invite: {
      title: '¿Reenviar la invitación a {{email}}?',
      description:
        'El propietario recibirá una nueva contraseña por correo electrónico. Su contraseña actual dejará de funcionar.',
    },
  },
  toasts: {
    successfully_created_manager: 'Gestor creado correctamente',
    owner_invited:
      '{{email}} ha sido invitado como propietario del restaurante y recibirá sus datos de acceso por correo electrónico.',
    failed_to_load_data: 'Error al cargar los datos, actualice la página',
    failed_to_create_manager: 'Error al crear el gestor',
    failed_to_create_magic_link: 'Error al crear el enlace mágico',
    failed_to_delete_manager: 'Error al eliminar el gestor',
    manager_got_deleted: 'Gestor eliminado',
    successfully_updated_manager: 'Gestor actualizado',
    failed_to_update_manager: 'Error al actualizar el gestor',
    owner_invite_resent: 'La invitación se envió de nuevo a {{email}}, con una nueva contraseña.',
    owner_invite_resend_cooling_down:
      'La invitación se acaba de reenviar. Espera unos minutos antes de volver a enviarla.',
    failed_to_resend_owner_invite: 'No se pudo reenviar la invitación',
  },
};
